export const filterPredicateIsTruthy = <V>(
    value: V | false | 0 | '' | undefined | null
): value is V => {
    return Boolean(value);
};
